import React, { memo } from 'react';
import { Box } from '@material-ui/core';

import { HelpVideoItem } from '../../HelpVideoItem';

import { AddMapToHelpVideoButton } from './AddMapToHelpVideoButton';
import { EditHelpVideoButton } from './EditHelpVideoButton';
import { DestroyHelpVideoButton } from './DestroyHelpVideoButton';

import { useStyles } from './styles';

export const Item = memo(
  ({
    // Universal
    helpVideo,

    // Add Map resources
    alreadyAdded = false,
    currentPath = '',
    getMappedHelpVideos,

    // Remove HelpVideo resources
    getHelpVideosToSelect,
  }) => {
    const classes = useStyles();

    return (
      <Box className={classes.container}>
        <HelpVideoItem helpVideo={helpVideo} light />

        <Box className={classes.floatingContainer}>
          <Box className={classes.floatingContainerWrapper}>
            <AddMapToHelpVideoButton
              helpVideo={helpVideo}
              alreadyAdded={alreadyAdded}
              currentPath={currentPath}
              getMappedHelpVideos={getMappedHelpVideos}
            />

            <EditHelpVideoButton
              helpVideo={helpVideo}
              getHelpVideosToSelect={getHelpVideosToSelect}
            />
          </Box>

          <DestroyHelpVideoButton
            helpVideo={helpVideo}
            getHelpVideosToSelect={getHelpVideosToSelect}
          />
        </Box>
      </Box>
    );
  },
);
